import common from './global/common'
import customPlp from './global/custom-plp'
import customPdp from './global/custom-pdp'
import customCheckout from './global/custom-checkout'
import desktopNavigation from './global/desktop-navigation'
import footer from './global/footer'
import mobileNavigation from './global/mobile-navigation'
import spinner from './global/spinner'

export default {
    ...common,
    ...customPlp,
    ...customPdp,
    ...customCheckout,
    ...desktopNavigation,
    ...spinner,
    ...mobileNavigation,
    ...footer
}
